import { Component, OnInit, Inject } from '@angular/core';
import { AuthHelper } from '../services/auth.helper';
import { LoggerService } from '../services/logger.service';


export class HeaderComponent implements OnInit {

  constructor(
    private authHelper: AuthHelper,
     private loggerService: LoggerService
  ) { }

  ngOnInit() {
    this.loggerService.log('... initializing header component from core module.');
  }

  isActive(): boolean {
    return this.authHelper.isUserLogged();
  }

  getUser(): string | null {
    return this.authHelper.getUserLogged();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-layout-header]',
  template: `
  <div class="navbar-header" style="display: table;">
    <div style="display: table-row;">
      <div style="display: table-cell;"><a leaf-layout-minimalize></a></div>
      <div style="display: table-cell; vertical-align: middle; height: 60px;">
        <ng-content select="[header-left]"></ng-content>
      </div>
      <div style="display: table-cell; padding-left: 10px; vertical-align: middle;" leaf-spinner></div>
    </div>
  </div>
  <ng-content select="[header-right]"></ng-content>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AuthHelper, },
{type: LoggerService, decorators: [{ type: Inject, args: ['LoggerService', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
